<script>
import PriceHistoryChart from "@/components/PriceHistoryChart.vue";
import MediumLoader from "@/components/Loader/MediumLoader.vue";

export default {
    name: "PriceHistory",
    components: {MediumLoader, PriceHistoryChart},
    props: {
        plz: {
            type: String,
            required: true,
        },
        tarifId: {
            type: String,
            required: true,
        },
        color: {
            type: String,
            default: 'green'
        },
        regularPrice: {
            type: Number,
        },
        hideRegular: {
            type: Boolean,
            default: false,
        },
        hideAverage: {
            type: Boolean,
            default: false,
        },
        hideSwitchDay: {
            type: Boolean,
            default: false,
        },
        hideSwitchSavings: {
            type: Boolean,
            default: false,
        },
        textBefore: {
            type: String,
        },
        textAfter: {
            type: String,
        },
        apiUrl: {
            type: String,
            default: '/?type=45637&tx_uopreisrechner_preisrechner[action]=getAllInPrices&tx_uopreisrechner_preisrechner[controller]=FlexApi',
        },
    },
    data() {
        return {
            showDay: false,
            showSavings: false,
            loading: true,

            dataYear: null,
            dataDay: null,
            averagePriceYear: 0,
            averagePriceDay: 0,
        }
    },
    methods: {
        fetch() {
          if (this.showDay && this.dataDay === null) {
              this.loading = true;
              this.fetchDay().finally(() => this.loading = false)
          } else if(!this.showDay && this.dataYear === null) {
              this.loading = true;
              this.fetchYear().finally(() => this.loading = false)
          }
        },
        fetchYear() {
            if (this.isFetchingYear) return Promise.resolve();
            const url = `${this.apiUrl}&tx_uopreisrechner_preisrechner[tarifId]=${this.tarifId}&tx_uopreisrechner_preisrechner[plz]=${this.plz}&tx_uopreisrechner_preisrechner[diagramType]=year`
            this.isFetchingYear = true;
            return fetch(url)
                .then(data => data.json())
                .then(data => {
                    this.averagePriceYear = data.average
                    this.dataYear = data
                });
        },
        fetchDay() {
            if (this.isFetchingDay) return Promise.resolve();
            const url = `${this.apiUrl}&tx_uopreisrechner_preisrechner[tarifId]=${this.tarifId}&tx_uopreisrechner_preisrechner[plz]=${this.plz}&tx_uopreisrechner_preisrechner[diagramType]=day`
            this.isFetchingDay = true
            return fetch(url)
                .then(data => data.json())
                .then(data => {
                    this.averagePriceDay = data.average
                    this.dataDay = data
                });
        },
        formatNumber(number, maxDigits, minDigits) {
            if (typeof maxDigits === 'undefined') maxDigits = 1
            if (typeof minDigits === 'undefined') minDigits = 1
            return new Intl.NumberFormat('de-DE', {minimumFractionDigits: minDigits, maximumFractionDigits: maxDigits}).format(number)
        },
    },
    mounted() {
        this.fetch()
    },
    watch: {
        showDay: function() {
            this.fetch();
        }
    }
}
</script>

<template>
    <div class="price-history">
        <div class="text-before" v-if="textBefore" v-html="textBefore"></div>
        <MediumLoader v-if="loading" />
        <div class="chart-container isVis" v-else>
            <PriceHistoryChart
                v-if="dataYear"
                id="chart-year"
                :data="dataYear.prices"
                :class="[color, {off: showDay, 'show-savings': showSavings}]"
                :regular-value="regularPrice"
                :hide-regular="hideRegular"
            />

            <PriceHistoryChart
                v-if="dataDay"
                id="chart-day"
                class="day"
                :class="[color, {off: !showDay, 'show-savings': showSavings}]"
                :data="dataDay.prices"
                :label-interval="6"
                :regular-value="regularPrice"
                :hide-regular="hideRegular"
            />
        </div>
        <div
            v-show="!loading"
            class="chart-functions"
            :class="{
                'hide-average': hideAverage,
                'hide-switch-24': hideSwitchDay,
                'hide-switch-savings': hideSwitchSavings,
            }"
        >
            <div class="chart-switches col-md-6">
                <div id="time">
                    <label for="time-switch">Strompreisverlauf der letzten 24 Stunden anzeigen</label>
                    <span class="custom-check">
                        <input type="checkbox" id="time-switch" v-model="showDay">
                    </span>
                </div>
                <div id="savings">
                    <label for="savings-switch">Ersparnis anzeigen</label>
                    <span class="custom-check">
                        <input type="checkbox" id="savings-switch" v-model="showSavings">
                    </span>
                </div>
            </div>
            <div class="legend-average col-md-6">
                Durchschnittspreis:
                <span id="averageValueYear" v-show="!showDay">{{ formatNumber(averagePriceYear) }}</span>
                <span id="averageValueDay" v-show="showDay">{{ formatNumber(averagePriceDay) }}</span>
                <small>ct/kWh</small>
            </div>
        </div>
        <div class="text-after legal" :class="color" v-if="textAfter" v-html="textAfter"></div>
    </div>
</template>

